import { render, staticRenderFns } from "./coreImage.vue?vue&type=template&id=01e48a24"
import script from "./coreImage.vue?vue&type=script&lang=js"
export * from "./coreImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports